import React, { useEffect, useState, useRef, Fragment } from "react";
import getMedallero from "../../services/getMedallero.js";
import Loading from "components/loading/loading.js";
import CardPais from "./cardPais/cardPais.js";
import Header from "./header/header.js";
import "./medallero.sass";

export default function Medallero({ longitud, seccion }) {
    const [showLoading, setShowLoading] = useState(true);
    const [datos, setDatos] = useState(null);
    const [ordenAlfabetico, setOrdenAlfabetico] = useState(false); // por defeto A-Z al presionar Z-A
    const [ordenOro, setOrdenOro] = useState(false); // mayor a menor
    const [ordenPlata, setOrdenPlata] = useState(false); // mayor a menor
    const [ordenBronce, setOrdenBronce] = useState(false); // mayor a menor
    const [ordenTotal, setOrdenTotal] = useState(false); // mayor a menor

    // variables para establer el ordenamiento
    const ascendente = "ASC";
    const descendente = "DESC";

    useEffect(() => {
        if (datos === null) {
            setShowLoading(true);
        } else {
            setShowLoading(false);
        }
    }, [datos]);

    useEffect(() => {
        getMedallero(seccion).then((medallas) => {
            const tieneOro = medallas && medallas.data && medallas.data.some((medalla) => medalla.gold !== 0);

            if(medallas && medallas.data){
                const datosOrdenados = [...medallas.data].sort((a, b) => {
                    const totalA = a.gold;
                    const totalB = b.gold;

                    if (!tieneOro) {
                        // Orden alfabético por país
                        setOrdenOro(false);
                        setOrdenPlata(false);
                        setOrdenBronce(false);
                        setOrdenTotal(false);
                        setOrdenAlfabetico(ascendente);
                        return a.organisation.localeCompare(b.organisation);
                    } else {
                        setOrdenOro(descendente);
                        setOrdenAlfabetico(false);

                        // Si tienen la misma cantidad de oro, compara plata
                        if (totalA === totalB) {
                            const totalPlataA = a.silver;
                            const totalPlataB = b.silver;

                            if (totalPlataA === totalPlataB) {
                                // Si también tienen la misma cantidad de plata, compara bronce
                                return b.bronze - a.bronze;
                            }

                            return totalPlataB - totalPlataA;
                        }

                        return totalB - totalA;
                    }
                });

                setDatos(datosOrdenados);
            }
        });
    }, [seccion]);


    const FilterAlfabetico = () => {
        if (ordenAlfabetico === false || ordenAlfabetico === ascendente) {
            setOrdenAlfabetico(descendente);
            const datosOrdenados = [...datos].sort((a, b) =>
                b.organisation.localeCompare(a.organisation)
            );
            setDatos(datosOrdenados);
        } else if (ordenAlfabetico === descendente) {
            setOrdenAlfabetico(ascendente);
            const datosOrdenados = [...datos].sort((a, b) =>
                a.organisation.localeCompare(b.organisation)
            );
            setDatos(datosOrdenados);
        }

        setOrdenOro(false);
        setOrdenPlata(false);
        setOrdenBronce(false);
        setOrdenTotal(false);
    };

    const FilterGold = () => {
        if (ordenOro === false || ordenOro === ascendente) {
            setOrdenOro(descendente);

            const datosOrdenados = [...datos].sort((a, b) => {
                // Manejar el caso en el que 'total' es una cadena vacía
                const totalA = a.gold;
                const totalB = b.gold;

                // Si tienen la misma cantidad de oro, compara plata
                if (totalA === totalB) {
                    const totalPlataA = a.silver;
                    const totalPlataB = b.silver;

                    if (totalPlataA === totalPlataB) {
                        // Si también tienen la misma cantidad de plata, compara bronce
                        const totalBronceA = a.bronze;
                        const totalBronceB = b.bronze;

                        return totalBronceB - totalBronceA;
                    }
                    return totalPlataB - totalPlataA;
                }
                return totalB - totalA;
            });

            setDatos(datosOrdenados);
        

        } else if (ordenOro === descendente) {
            setOrdenOro(ascendente);

            const datosOrdenados = [...datos].sort((a, b) => {
                // Manejar el caso en el que 'total' es una cadena vacía
                const totalA = a.gold;
                const totalB = b.gold;

                // Si tienen la misma cantidad de oro, compara plata
                if (totalA === totalB) {
                    const totalPlataA = a.silver;
                    const totalPlataB = b.silver;

                    if (totalPlataA === totalPlataB) {
                        // Si también tienen la misma cantidad de plata, compara bronce
                        const totalBronceA = a.bronze;
                        const totalBronceB = b.bronze;

                        return totalBronceA - totalBronceB;
                    }

                    return totalPlataA - totalPlataB;
                }

                return totalA - totalB;
            });
            setDatos(datosOrdenados);
        
        }

        setOrdenAlfabetico(false);
        setOrdenPlata(false);
        setOrdenBronce(false);
        setOrdenTotal(false);
    };

    const FilterSilver = () => {
        if (ordenPlata === false || ordenPlata === ascendente) {
            setOrdenPlata(descendente);

            const datosOrdenados = [...datos].sort((a, b) => {
                // Manejar el caso en el que 'total' es una cadena vacía
                const totalA = a.silver;
                const totalB = b.silver;

                if (totalA === totalB) {
                    // Si también tienen la misma cantidad de plata, compara bronce
                    const totalBronceA = a.bronze;
                    const totalBronceB = b.bronze;

                    return totalBronceB - totalBronceA;
                }

                return totalB - totalA;
            });
            setDatos(datosOrdenados);
        } else if (ordenPlata === descendente) {
            setOrdenPlata(ascendente);

            const datosOrdenados = [...datos].sort((a, b) => {
                // Manejar el caso en el que 'total' es una cadena vacía
                const totalA = b.silver;
                const totalB = a.silver;

                if(totalA === totalB){
                    const totalBronceA = b.bronze;
                    const totalBronceB = a.bronze;

                    return totalBronceB - totalBronceA;
                }
                return totalB - totalA;
            });
            setDatos(datosOrdenados);
        }

        setOrdenAlfabetico(false);
        setOrdenOro(false);
        setOrdenBronce(false);
        setOrdenTotal(false);
    };

    const FilterBronce = () => {
        if (ordenBronce === false || ordenBronce === ascendente) {
            setOrdenBronce(descendente);

            const datosOrdenados = [...datos].sort((a, b) => {
                // Manejar el caso en el que 'total' es una cadena vacía
                const totalA = a.bronze;
                const totalB = b.bronze;
                
                return totalB - totalA;
            });
            setDatos(datosOrdenados);

        } else if (ordenBronce === descendente) {
            setOrdenBronce(ascendente);

            const datosOrdenados = [...datos].sort((a, b) => {
                // Manejar el caso en el que 'total' es una cadena vacía
                const totalA = b.bronze;
                const totalB = a.bronze;

                return totalB - totalA;
            });
            setDatos(datosOrdenados);
        }

        setOrdenAlfabetico(false);
        setOrdenOro(false);
        setOrdenPlata(false);
        setOrdenTotal(false);
    };

    const FilterTotal = () => {
        if (ordenTotal === ascendente || ordenTotal === false) {
            setOrdenTotal(descendente);

            const datosOrdenados = [...datos].sort((a, b) => {
                // Manejar el caso en el que 'total' es una cadena vacía
                const totalA = a.total;
                const totalB = b.total;

                return totalB - totalA;
            });
            setDatos(datosOrdenados);
        } else if (ordenTotal === descendente) {
            setOrdenTotal(ascendente);

            const datosOrdenados = [...datos].sort((a, b) => {
                // Manejar el caso en el que 'total' es una cadena vacía
                const totalA = b.total;
                const totalB = a.total;

                return totalB - totalA;
            });
            setDatos(datosOrdenados);
        }
        setOrdenAlfabetico(false);
        setOrdenOro(false);
        setOrdenPlata(false);
        setOrdenBronce(false);
    };

    //------- INICIAR EJECUCION DE REZISE DEL COMPONENTE -------
    const medalleroRef = useRef(null);

    useEffect(() => {
        const resizeObserver = new ResizeObserver((entries) => {
            entries.forEach((entry) => {
                const newHeight = entry.contentRect.height;

                window.requestAnimationFrame(() => {
                    const message = {
                        sentinel: "amp",
                        type: "embed-size",
                        height: newHeight,
                    };
                    window.parent.postMessage(message, "*");
                });
            });
        });

        if (medalleroRef.current) {
            resizeObserver.observe(medalleroRef.current);
        }

        // Limpia el ResizeObserver al desmontar el componente
        return () => {
            resizeObserver.disconnect();
        };
    }, [medalleroRef]);
    //------- TERMINA EJECUCION DE REZISE DEL COMPONENTE -------

    return (
        <div
            id="medallero-container"
            className="medallero-container"
            ref={medalleroRef}
        >
            {showLoading ? (
                <>
                    <Header
                        ascendente={ascendente}
                        descendente={descendente}
                        ordenAlfabetico={ordenAlfabetico}
                        ordenBronce={ordenBronce}
                        ordenOro={ordenOro}
                        ordenPlata={ordenPlata}
                        ordenTotal={ordenTotal}
                        FilterGold={FilterGold}
                        FilterSilver={FilterSilver}
                        FilterBronce={FilterBronce}
                        FilterAlfabetico={FilterAlfabetico}
                        FilterTotal={FilterTotal}
                    />

                    <Loading />
                </>
            ) : (
                <>
                    <Header
                        ascendente={ascendente}
                        descendente={descendente}
                        ordenAlfabetico={ordenAlfabetico}
                        ordenBronce={ordenBronce}
                        ordenOro={ordenOro}
                        ordenPlata={ordenPlata}
                        ordenTotal={ordenTotal}
                        FilterGold={FilterGold}
                        FilterSilver={FilterSilver}
                        FilterBronce={FilterBronce}
                        FilterAlfabetico={FilterAlfabetico}
                        FilterTotal={FilterTotal}
                    />

                    {datos &&
                        datos.map(
                            (pais, indice) =>
                                pais && String(pais.organisation).length > 0 &&
                                ((indice + 1 <= longitud && longitud) || !longitud) && (
                                    <Fragment key={pais._id}>
                                        <CardPais _id={pais._id} organisation={pais.organisation} gold={pais.gold} silver={pais.silver} bronze={pais.bronze} total={pais.total} />
                                    </Fragment>
                                )
                        )
                    }
                </>
            )}
        </div>
    );
}
